import {useState,useEffect} from 'react'
import {subscribe} from '@services/events'

let createEvent = null;
subscribe(document,'sections:create', e=>createEvent = e);

export default function useSections(){
  const [sections,setSections] = useState([]);
  const [currentIndex,setCurrentIndex] = useState(-1);

  useEffect(()=>{
    if(createEvent){
      setSections(createEvent.detail.elements);
      setCurrentIndex(createEvent.detail.currentIndex);
    }
    return subscribe(document,'sections:change sections:create',e=>{
      setSections(e.detail.elements);
      setCurrentIndex(e.detail.currentIndex);
    });
  },[]);

  return [currentIndex,sections];
}
